import AuthApi from 'api/AuthApi';

import { NavigationbarUrl } from './Navigationbar';

export const FeatureNavUrls: NavigationbarUrl[] = [
  {
    mobile: true,
    title: 'Disease Activity',
    children: [
      {
        title: 'Show All Activity',
        routerLink: '/all',
      },
      {
        title: 'Show by My Locations',
        routerLink: '/location',
      },
    ],
  },
];

export const AdminNavUrls: NavigationbarUrl[] = [
  {
    mobile: false,
    title: 'Administration',
    children: [
      {
        title: 'User Types Admin',
        routerLink: '/admin-settings/usertypes',
      },
      {
        title: 'User Groups Admin',
        routerLink: '/admin-settings/usergroups',
      },
      {
        title: 'Users Admin',
        routerLink: '/admin-settings/useradmin',
      },
      {
        title: 'Disease Groups Admin',
        routerLink: '/admin-settings/diseasegroup',
      },
      {
        title: 'Role to Disease Relevance Admin',
        routerLink: '/admin-settings/rolediseaserelevance',
      },
      {
        title: 'User Email Types',
        routerLink: '/admin-settings/useremailtypes',
      },
    ],
  },
];

export const SettingNavUrls: NavigationbarUrl[] = [
  {
    mobile: true,
    title: 'Settings',
    icon: 'icon-profile',
    direction: 'left',
    children: [
      {
        title: 'Account Details',
        routerLink: '/settings/account',
      },
      {
        title: 'Insights Settings',
        routerLink: '/settings/customsettings',
      },
      {
        title: 'Notification Settings',
        routerLink: '/settings/notifications',
      },
      {
        title: 'Sign Out',
        onClick: () => AuthApi.logOut(),
      },
    ],
  },
];
